
<template>
  <!--消费记录-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      :apiOrigin="apiOrigin"
      ref="table"
      :excludeResetKey="memberId"
      :dataSource="dataSource"
      rowKey="id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_type" slot-scope="{row}">
        <span>{{consumptionType[row.type]}}</span>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <span class="text-color" :class="{acitve: row.type === 1 || row.type === 3}">{{row.money}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'consumeRecord',
  data () {
    return {
      apiOrigin: 'JAVA',
      memberId: [],
      consumptionType: {
        1: '充值',
        2: '访客提醒扣费',
        3: '退款-访客提醒扣费',
        4: '补扣-访客提醒扣费'
      },
      searchList: [
        { props: ['keywords'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '消费类型', options: [], inputType: 'select' },
        { props: ['createDate'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [],
      columns: [
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '消费类型', dataIndex: 'type', align: 'left', width: '', scopedSlots: {customRender: 'type'} },
        { title: '金额(¥)', dataIndex: 'money', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '时间', dataIndex: 'createTime', align: 'left', width: '' }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined,
        type: undefined,
        createDate: undefined
      },
      listApi: {
        url: '/member/paylog/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.routeQuery = this.$route.query.id;
    if (this.routeQuery) {
      this.searchList.splice(0, 1);
      this.memberId = ['memberId'];
      this.searchParams.memberId = this.routeQuery;
    } else {
      this.memberId = [];
    }
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_balance_type',
        params: {}
      }).then(({data}) => {
        if (this.routeQuery) {
          this.searchList[0].options = data;
        } else {
          this.searchList[1].options = data;
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="less" scoped>
.text-color{ color: #2CC532; }
.acitve{ color: #FF4B4B;}
</style>
